import {
  PRODUCTION,
  FACEBOOKPIXEL,
  TAGMANAGER_ID,
  ANALYTICS_ID,
} from '@globals';

export function initTagManager(id) {
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', id);
}

function initFacebookTracking() {
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js'
  );
}
export function analytics(event) {
  if (!window.dataLayer) {
    window.dataLayer = [];
    initTagManager(TAGMANAGER_ID);
  }
  const version = TO_VERSION || 'dev';
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({ ...event, version });
  return window.dataLayer || [];
}

const initializedFacebookTrackers = [];
export function facebookTracking(
  id = FACEBOOKPIXEL,
  type = 'PageView',
  options
) {
  if (!PRODUCTION) {
    return;
  }
  if (!window.fbq) {
    initFacebookTracking();
  }

  if (!initializedFacebookTrackers.includes(id)) {
    initializedFacebookTrackers.push(id);
    window.fbq('init', id);
  }
  const version = TO_VERSION || 'dev';

  window.fbq('version', version);
  window.fbq('trackSingle', id, type, options);
}

export function mapRestaurantForAnalytics({
  name = '[Error]',
  restaurantId = 309,
  city = '[Unknown]',
  features = [],
}) {
  const lang =
    document.documentElement.lang === 'et'
      ? 'ee'
      : document.documentElement.lang;
  return {
    item_name: name,
    item_id: restaurantId,
    price: 1.8,
    currency: 'EUR',
    item_variant: 'Restaurant',
    item_category: city,
    item_category2: (features.filter(item => item.category === 'kitchen')[0] ||
      {})[lang],
  };
}

export default analytics;



// WEBPACK FOOTER //
// ./analytics.js